import React from 'react';
import { CBadge } from '@coreui/react';

const AffectedTypeBadge = ({ type }: { type: string }) => {
  const colors: any = {
    LEAD: 'success',
    CUSTOMER: 'primary',
    ROLE: 'primary',
    INSTRUMENT: 'warning',
    CURRENCY_CONVERSION: 'secondary',
    COMMISSION_LEDGER_RECORD: 'dark',
    COMMISSION_PAYOUT_REQUEST: 'info',
    POSITION: 'warning',
    ORDER: 'warning',
    WALLET: 'primary',
    CHALLENGE_TYPE: 'info',
    FUNDED_ACCOUNT_TYPE: 'info',
    PROP_FUNNEL: 'info',
    CUSTOMERS: 'primary',
    TRANSACTION: 'info',
    PAYMENT_PROVIDER: 'warning',
  };

  return <CBadge color={colors[type]}>{type}</CBadge>;
};

export default AffectedTypeBadge;
